// create-empty-github-repo.ts
//
// v3: Tạo repo GitHub RỖNG (không cần folder source) cho flow "avatar add repo →
// dự án mới". Capture stderr để classify lỗi (tên trùng / sai quyền / sai account)
// cho recovery menu.
import { spawnSync } from "node:child_process";
import { resolveGithubUsernameDefault } from "./resolve-github-username-default.js";
import { log } from "./terminal-logger.js";

export type RepoCreateFailReason = "name-exists" | "no-permission" | "network" | "unknown";

export class RepoCreateError extends Error {
  reason: RepoCreateFailReason;
  constructor(reason: RepoCreateFailReason, message: string) {
    super(message);
    this.name = "RepoCreateError";
    this.reason = reason;
  }
}

// Classify gh repo create stderr → reason code cho recovery menu.
export function classifyRepoCreateError(stderr: string): RepoCreateFailReason {
  const t = stderr.toLowerCase();
  if (t.includes("name already exists") || t.includes("already exists")) return "name-exists";
  if (
    t.includes("403") ||
    t.includes("permission") ||
    t.includes("not have access") ||
    t.includes("resource not accessible")
  ) {
    return "no-permission";
  }
  if (t.includes("could not resolve") || t.includes("network") || t.includes("timeout")) {
    return "network";
  }
  return "unknown";
}

// Tạo repo rỗng trên GitHub, trả SSH clone URL. Throw RepoCreateError (có reason)
// nếu fail → caller offer recovery menu.
export async function createEmptyGithubRepoAndGetUrl(
  name: string,
  visibility: "private" | "public",
  org?: string,
): Promise<string> {
  const owner = org ?? resolveGithubUsernameDefault();
  const fullName = `${owner}/${name}`;
  log.info(`Tạo GitHub repo rỗng ${fullName} (${visibility})...`);

  // Tạo repo RỖNG (KHÔNG --add-readme) — caller scaffold local + push lên sạch,
  // tránh conflict "remote có README, local có commit khác". Capture stderr để classify.
  const r = spawnSync("gh", ["repo", "create", fullName, `--${visibility}`], {
    stdio: ["ignore", "pipe", "pipe"],
    encoding: "utf8",
  });
  if (r.status !== 0) {
    const stderr = (r.stderr || "").trim();
    if (stderr) process.stderr.write(`${stderr}\n`);
    throw new RepoCreateError(classifyRepoCreateError(stderr), `Tạo repo ${fullName} thất bại.`);
  }

  log.success(`Đã tạo: git@github.com:${fullName}.git`);
  return `git@github.com:${fullName}.git`;
}
